import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { getPurchaseHistory, clearPurchaseHistory } from '../Firebase/firestoreUtils.js'; // Adjust the path as necessary // Adjust the import based on your structure

const PurchaseHistoryPopup = ({ isOpen, onClose, userId }) => {
    const [purchaseHistory, setPurchaseHistory] = useState([]);
    const [error, setError] = useState(null);
    const user = userId ? userId.uid : null;

    useEffect(() => {
        if (isOpen && user) {
            const fetchPurchaseHistory = async () => {
                try {
                    const history = await getPurchaseHistory(user); // Fetch from your API
                    setPurchaseHistory(history);
                    setError(null); // Clear any previous errors
                } catch (err) {
                    console.error("Error fetching purchase history:", err);
                    setError("Failed to fetch purchase history. Please check your internet connection."); // Set error message
                }
            };
            fetchPurchaseHistory();
        } else {
            setPurchaseHistory([]); // Clear purchase history if user is null
        }
    }, [isOpen, user]);

    const handleClearHistory = async () => {
        if (user) {
            // Call the function to clear purchase history in the database
            await clearPurchaseHistory(user);
            setPurchaseHistory([]); // Clear local state
        }
    };

    return (
        <Modal show={isOpen} onHide={onClose} className='purch-mod' centered size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Purchase History</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {error ? ( // Check for error state
                    <p style={{ color: 'red' }}>{error}</p> // Display error message
                ) :
                    purchaseHistory.length > 0 ? (
                        <ul>
                            {purchaseHistory.map((purchase, index) => {
                                // Handle cart purchases (with items array)
                                if (Array.isArray(purchase.items)) {
                                    return purchase.items.map((item, idx) => (
                                        <li
                                            key={`${index}-${idx}`}
                                            style={{
                                                display: "flex",
                                                flexDirection: "row",
                                                justifyContent: "space-between",
                                                padding: "10px 10px 10px 0px",
                                                alignItems: "center",
                                            }}
                                        >
                                            <div className="telly">
                                            <img src={purchase.thumbnail || purchase.items.thumbnail || "https://firebasestorage.googleapis.com/v0/b/meteoyama-414fe.appspot.com/o/Images%2FMascot%2FGrown%20Mete%20Mascot.png?alt=media&token=a554d1a2-4246-4426-8a04-001f97dfe21e"} alt={purchase.itemName} style={{ width: '50px', height: 'auto', display: "flex", marginRight: '10px' }} />
                                                <div className="imago"   style={{ textAlign: "left"}}>
                                                    <h5 style={{fontSize: '18px'}}>{item.name}</h5>
                                                    <p style={{fontSize: '12px'}}>Date: {new Date(purchase.date).toLocaleDateString()}</p>
                                                </div>
                                            </div>
                                            <p><strong>₦{purchase.totalAmount}</strong></p>
                                            {item.downloadUrl && (
                                                <a
                                                    href={item.downloadUrl}
                                                    download
                                                    className="PayBtn btn btn-sm"
                                                    style={{ textDecoration: "none" }}
                                                >
                                                    Download
                                                </a>
                                            )}
                                        </li>
                                    ));
                                }

                                // Handle single item purchases
                                return (
                                    <li
                                        key={index}
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "space-between",
                                            padding: "10px 10px 10px 0px",
                                            alignItems: "center",
                                        }}
                                    >
                                        <div className="telly">
                                        <img src={purchase.thumbnail || "../images/pieces/Grown_Mete_Mascot.png"} alt={purchase.itemName} style={{ width: '50px', height: 'auto', display: "flex", marginRight: '10px' }} />
                                            <div className="imago"  style={{ textAlign: "left"}}>
                                                <h5 style={{fontSize: '18px'}}>{purchase.itemName}</h5>
                                                <p style={{fontSize: '12px'}}>Date: {new Date(purchase.date).toLocaleDateString()}</p>
                                            </div>
                                        </div>
                                        <p><strong>₦{purchase.amount}</strong></p>
                                        {purchase.downloadUrl && (
                                            <a
                                                href={purchase.downloadUrl}
                                                download
                                                className="PayBtn btn btn-sm"
                                                style={{ textDecoration: "none" }}
                                            >
                                                Download
                                            </a>
                                        )}
                                    </li>
                                );
                            })}

                        </ul>
                    ) : (
                        <p>No purchase history found.</p>
                    )}
            </Modal.Body>
            <Modal.Footer className='purch-footer'>
                <Button className='ClosePayBtn' onClick={handleClearHistory}>
                    Clear Purchase History
                </Button>
                <Button className='PayBtn' onClick={onClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default PurchaseHistoryPopup;